import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';






function TrainerReport(props) {

  let { } = props;


  const { userData, api, refAccountTrainer, accountTrainerData, } = useContext(DataContext);
  const userRole = userData.role;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);



  useEffect(() => {
    const fetchData = async () => {
      try {
        await refAccountTrainer();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  const trainerOptions = accountTrainerData.map(item => ({
    value: item.id,
    label: item.name,
  }));
  trainerOptions.push({ value: null, label: 'All Trainers' })



  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', fromDate: today, toDate: today });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [account, setAccount] = useState([]);

  const [trainer, setTrainer] = useState([]);
  const [clas, setClas] = useState([]);
  const [type, setType] = useState('');
  const [transction, setTransction] = useState({});

  const table = 'trainerReport';
  const title = 'NewTransaction';



  const addModal = () => {
    if (filter.accountID) {
      setIdRow([]);
      resetForm();
      setShowAddModal(!showAddModal);
    } else {
      toast.error('Please Select a Tainer')
    }
  }



  const resetForm = () => {
    setTransction({ createdBy: createdBy, type: type })
    setClas('')
  }


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }



    setTransction((prevTransction) => ({
      ...prevTransction,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setClas(selectedOption)
    setTransction((prevTransction) => ({
      ...prevTransction,
      [name]: selectedOption.value,

    }));
  };


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }



  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        account: item.account?.name,
      };

      transformedData.push(newItem);
    });

    return transformedData;
  };





  let newColumnDefs = [
    { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Barcode', dataIndex: 'member', render: (member) => (member?.barcode) },
    { title: 'member', dataIndex: 'member', render: (member) => (member?.name) },
    { title: 'class', dataIndex: 'class', render: (e) => (e?.name) },
    { title: 'trainer', dataIndex: 'trainer', render: (trainer) => (trainer?.name) },
    { title: 'type', dataIndex: 'type', render: typeFormatter },
    { title: 'price', dataIndex: 'usd', width: '8%' },
    { title: 'RegistrationDate', dataIndex: 'registrationDate' },
    { title: 'ExpiryDate', dataIndex: 'expiryDate' },
  ]; 



  useEffect(() => {

    setColumnDefs(newColumnDefs);

  }, [filter.isActive]);


  const formView = (<></>);





  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>

        <span className='table-footer footer-one'>Visits:   {numberFormatter(data?.summary?.visitCount, 2)}</span>
        <span className='table-footer footer-one'> Memberships:  {numberFormatter(data?.summary?.membershipCount, 2)} </span>
        <span className='table-footer footer-green'> Balance:  {numberFormatter(data?.summary?.totalIn + data?.summary?.totalCredit, 2)} </span>
      </div>
    </div>
  );


  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <DatePicker setFilter={setFilter} filter={filter} />



            <DataFilter selectedOption={trainerOptions?.find(option => option.value === filter.trainerId)} 
              setFilter={setFilter} dataOptions={trainerOptions} filterBy={'trainerId'} placeHolder={'All Trainers'} />




          </div>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ transction }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, transction }}
          />

          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />



        </>
      }

    </div>
  )
}

export default TrainerReport;
